import React, { useEffect, useState } from 'react';
import store from '../../../store';
import { connect } from "react-redux";
import { stopTimer } from '../common/helper';
import GuestMobileEmail from '../common/guestMobileEmail';

const MobileEmailTxn = () => {

    const props = store.getState();
    
    useEffect(() => {
        stopTimer();
    }, [])

    return (
        <>
            {<div className='bookingStatus_container' style={{ width: '100%' }}>
                <GuestMobileEmail />
            </div>
            }
        </>
    )
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(MobileEmailTxn);